var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Image, Tile } from 'ol/layer';
import { ImageWMS, TileWMS } from 'ol/source';
import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../hocs/ensureMap';

export var WmsLayer = function (_React$Component) {
  _inherits(WmsLayer, _React$Component);

  function WmsLayer() {
    _classCallCheck(this, WmsLayer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  WmsLayer.prototype.componentDidMount = function componentDidMount() {
    this.addLayer(this.props);
  };

  WmsLayer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var map = nextProps.map;

    if (nextProps.map === this.props.map && this.uriCompare(this.props.uri, nextProps.uri) && nextProps.layerName === this.props.layerName) {
      return;
    }

    map.removeLayer(map._layers[this.id]);
    delete map._layers[this.id];
    this.addLayer(nextProps);
  };

  WmsLayer.prototype.uriCompare = function uriCompare(uri, nextUri) {
    if (Array.isArray(uri) && Array.isArray(nextUri)) {
      return uri.join(',') === nextUri.join(',');
    }
    return uri === nextUri;
  };

  WmsLayer.prototype.addLayer = function addLayer(props) {
    var map = props.map,
        layerName = props.layerName,
        version = props.version,
        uri = props.uri,
        singleTile = props.singleTile,
        projCode = props.projCode,
        minZoom = props.minZoom,
        maxZoom = props.maxZoom,
        zIndex = props.zIndex,
        getResolution = props.getResolution,
        onPreCompose = props.onPreCompose,
        onPostCompose = props.onPostCompose,
        useBaat = props.useBaat,
        baatToken = props.baatToken;

    var isUrlArray = Array.isArray(uri);

    if (!map) return;

    if (map._layers && map._layers[this.id]) {
      map._layers[this.id].setVisible(true);
      return;
    }

    var wmsLayerParams = {
      LAYERS: layerName,
      VERSION: version || '1.3.0'
    };
    if (useBaat && baatToken) {
      wmsLayerParams.GKT = baatToken;
    }

    map._layers = map._layers || {};
    map._layers[this.id] = singleTile ? new Image({
      minResolution: maxZoom && getResolution(maxZoom),
      maxResolution: minZoom && getResolution(minZoom),
      zIndex: zIndex,
      source: new ImageWMS({
        url: isUrlArray ? uri[0] : uri,
        params: wmsLayerParams,
        projection: projCode
      })
    }) : new Tile({
      minResolution: maxZoom && getResolution(maxZoom),
      maxResolution: minZoom && getResolution(minZoom),
      zIndex: zIndex,
      source: new TileWMS({
        url: isUrlArray ? undefined : uri,
        urls: isUrlArray ? uri : undefined,
        params: wmsLayerParams,
        projection: projCode
      })
    });

    if (onPreCompose) {
      map._layers[this.id].on('precompose', onPreCompose);
    }
    if (onPostCompose) {
      map._layers[this.id].on('postcompose', onPostCompose);
    }

    this.mountLayer();
  };

  WmsLayer.prototype.mountLayer = function mountLayer() {
    var map = this.props.map;

    if (!map) {
      setTimeout(this.mountLayer.bind(this), 200);
      return;
    }

    map.addLayer(map._layers[this.id]);
  };

  WmsLayer.prototype.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;

    map._layers[this.id].setVisible(false);
  };

  WmsLayer.prototype.render = function render() {
    return React.createElement('span', null);
  };

  _createClass(WmsLayer, [{
    key: 'id',
    get: function get() {
      return this.props.id;
    }
  }]);

  return WmsLayer;
}(React.Component);

WmsLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  uri: PropTypes.any.isRequired,
  id: PropTypes.string.isRequired,
  layerName: PropTypes.string.isRequired,
  version: PropTypes.string,
  singleTile: PropTypes.bool,
  useBaat: PropTypes.bool,
  baatToken: PropTypes.string,
  projCode: PropTypes.string,
  map: PropTypes.object,
  minZoom: PropTypes.number,
  maxZoom: PropTypes.number,
  zIndex: PropTypes.number,
  getResolution: PropTypes.func,
  onPreCompose: PropTypes.func,
  onPostCompose: PropTypes.func
} : {};
export default ensureMap(WmsLayer);